import { laneOccupationForm, ROAD_ORGAN } from "modules/ebiForms/definitions/sharedRoads";
import { EEbiFormOffice } from "modules/ebiForms/typings";

/**
 * B5. Wniosek o wydanie zezwolenia na zajęcie pasa drogowego drogi gminnej (urząd gminy) — art. 40 ust. 1–3 i 11 ustawy
 * o drogach publicznych; treść wniosku i załączniki: § 1 ust. 2, 3, 5 i 6 rozporządzenia RM z 1.06.2004 r. (t.j. Dz.U. 2016
 * poz. 1264). Brak wzoru ogólnopolskiego (rozporządzenie określa tylko treść wniosku); układ pól jak wzór Chodzieży
 * (https://samorzad.gov.pl/attachment/2cae5873-9a87-492c-a74d-cb24dec7328a — pobrany 2026-10-22: tak) uzupełniony o cele
 * z art. 40 ust. 2 (urządzenia obce, reklama, wyłączność). Wspólny builder z D1 i E8: definitions/sharedRoads.ts.
 * Opłata skarbowa nie jest pobierana; opłatę za zajęcie pasa ustala decyzja wg uchwały rady gminy (kalkulator — do
 * konfiguracji per urząd, poza silnikiem).
 */
const B5 = laneOccupationForm({
  code: "B5",
  title: "Wniosek o wydanie zezwolenia na zajęcie pasa drogowego drogi gminnej",
  description: "Zezwolenie na zajęcie pasa drogi gminnej: roboty, umieszczenie urządzeń obcych lub reklam, zajęcie na prawach wyłączności.",
  organ: ROAD_ORGAN.municipality,
  office: EEbiFormOffice.Municipality,
  road: "gminna",
});

export default B5;
